import { NO_IMAGE, NO_IMAGE_WITH_CAPTION } from "jd-library/src/constants/ImageIcons";
import React from "react";
import LazyLoad from "react-lazyload";
import { getRandomColorObj } from '../productImageUtils'

const _loadedImages = {};
const _errorImages = {};
const isPreviewDomain = typeof jdOmni != 'undefined' && jdOmni.isPreviewDomain;

export default class ImageLoader extends React.Component {
	//initial state: image loaded stage
	static defaultProps = {
		disableLazyLoad: true
	}
	state = {
		loaded: _loadedImages[this.props.imageSrc]
	};
	imageRef = React.createRef(null);
	randomColorObj = {
		width: '100%',
		height: '100%',
		zIndex: 1,
		position: 'absolute',
		...getRandomColorObj()
	}

	componentDidMount = () => {
		const image = this.imageRef.current;
		if (image && image.complete && image.naturalWidth != 0) {
			this.onLoad();
		} else {
			this.onError();
		}
	}
	//image onLoad handler to update state to loaded
	onLoad = () => {
		_loadedImages[this.getDownSize(this.props.actualPath, this.props.previewImage, this.props.loadOrignal)] = true;
		this.setState(() => ({ loaded: true }));
	};

	onError = () => {
		_errorImages[this.getDownSize(this.props.actualPath, this.props.previewImage, this.props.loadOrignal)] = true;
		this.setState(() => ({ loaded: false }));
	}

	getDownSize = (image, isLarge, loadOrignal) => {
		if (!image || image.indexOf("X") != -1 || image.indexOf("?fit=around") != -1 || loadOrignal) {
			return image;
		}
		if (isLarge) {
			return image.replace(/(\.jpg|\.jpeg|\.png)/g, "$1?fit=around|619:498");
		}
		return image.replace(/(\.jpg|\.jpeg|\.png)/g, "$1?fit=around|235:235");
	}


	render() {
		const { imageSrc, imgSrc, style, imgClass, imgAttrs } = this.props;
		const {
			base64Url,
			actualPath,
			uploaded,
			previewImage,
			loadOrignal,
			retainRandomColor,
			showNoImage,
			smallImage
		} = this.props;
		const loaderClass = this.state.loaded ? 'img-loaded' : 'img-loading';
		let finalImageSrc = base64Url || this.props.finalImageSrc;
		if (uploaded && !finalImageSrc) {
			finalImageSrc = this.getDownSize(actualPath, previewImage, loadOrignal);
		}
		if (_errorImages[finalImageSrc]) {
			finalImageSrc = showNoImage? 
				(smallImage?
					NO_IMAGE
					:
					NO_IMAGE_WITH_CAPTION)
				:
				actualPath;

		}
		let imageMarkup = (
			<React.Fragment>
				{(!this.state.loaded || retainRandomColor) && <div
					className={`${previewImage ? 'preview-image-wrapper' : ''}`}
					style={{
						...style,
						...this.randomColorObj
					}}
					onClick={() => {
						this.props.onClick && this.props.onClick()
					}
					} />}
				<img
					ref={this.imageRef}
					src={finalImageSrc}
					// style={(imgSrc && style) || {}}
					alt=''
					className={`${imgClass || 'prod-base-image'} ${loaderClass}`}
					{...imgAttrs}
					onLoad={this.onLoad}
					onError={this.onError}
					onClick={() => {
						this.props.onClick && this.props.onClick()
					}
					}
				/>
			</React.Fragment>
		);
		if (!isPreviewDomain && !this.props.disableLazyLoad) {
			imageMarkup = <LazyLoad
				offset={lazyLoadOffset || 650}
				once={true}
				{...this.props.lazyLoadProps}
			>{imageMarkup}</LazyLoad>;
		}
		return imageMarkup
	}
}